import React, { useState, useEffect } from "react";

import qr  from "./assets/images/qr.jpeg";

import slide1 from "./assets/images/1.jpg";
import slide2 from "./assets/images/2.jpg";
import slide3 from "./assets/images/3.jpg";

import hero from "./assets/images/hero.png";

import we1 from "./assets/images/we1.png";
import we2 from "./assets/images/we2.png";
import we3 from "./assets/images/we3.png";

import dl1 from "./assets/images/dl1.png";
import dl2 from "./assets/images/dl2.png";
import dl3 from "./assets/images/dl3.png";

import sm1 from "./assets/images/sm1.png";
import sm2 from "./assets/images/sm2.png";
import sc1 from "./assets/images/sc1.png";
import sc2 from "./assets/images/sc2.png";
import si1 from "./assets/images/si1.png";
import si2 from "./assets/images/si2.png";

/* ================= CONFIG ================= */

const TRUST_NAME = "Al Haidery Charitable Trust";
const LOCATION = "Nandurbar Initiative";
const WHATSAPP_NUMBER = "918265023256";

const TOTAL_AMOUNT = "₹925,000";

const SLIDES = [slide1, slide2, slide3];

const SLIDES_WE = [we1, we2, we3];
const SLIDES_DL = [dl1, dl2, dl3];

const DONATION_DATA = [
  {
    title: "Sponsor a Sewing Machine",
    price: "₹18,500",
    desc: "Enable a woman to earn a sustainable income. (Sewing Machine, Cupboard, Table and Sewing Accessories) ",
    images: [
      sm1,
      sm2
    ],
    details:
      "Your support provides a woman with the tools and training needed to start her own tailoring work. This creates a steady income source, helping her support her family and gain financial independence."
  },
  {
    title: "Sponsor a Computer",
    price: "₹65,000",
    desc: "Provide digital access to a student. (Computer, Monitor, Hardware, Software) ",
    images: [
      sc1,
      sc2
    ],
    details:
      "A single computer opens doors to digital education, online jobs, and modern skills. Students gain access to opportunities that were previously out of reach."
  },
  {
    title: "Support Infrastructure",
    price: "Any Amount",
    desc: "Help build the learning environment. (Tables, Chairs, Internet connection, Government approvals)",
    images: [
      si1,
      si2
    ],
    details:
      "Infrastructure support helps create a safe, functional, and inspiring learning environment where women and youth can grow, learn, and thrive."
  }
];


/* ================= APP ================= */

function App() {
  const [current, setCurrent] = useState(0);
const [currentWE, setCurrentWE] = useState(0);
const [currentDL, setCurrentDL] = useState(0);

  const [activeDonate, setActiveDonate] = useState(null);
const [donateSlide, setDonateSlide] = useState(0);

  const whatsapp = `https://wa.me/${WHATSAPP_NUMBER}`;

  useEffect(() => {
    const i = setInterval(() => {
      setCurrent((prev) => (prev + 1) % SLIDES.length);
    }, 5000); // slower, feels premium
    return () => clearInterval(i);
  }, []);

  return (
    <div className="bg-soft text-gray-800">

      {/* ================= HERO ================= */}
      <section className="bg-primary text-white py-24 text-center px-6"
      style={{
    backgroundImage: `url(${hero})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }} >
    <div className="absolute inset-0 bg-primary/75"></div>
    <div className="relative z-10">
        <h1 className="text-5xl font-bold">{TRUST_NAME}</h1>
        <p className="mt-3 text-blue-200">{LOCATION}</p>

        <p className="mt-6 max-w-2xl mx-auto text-lg text-blue-100">
          Empowering women and youth through education, skill development,
          and sustainable livelihood opportunities.
        </p>

        <div className="mt-8 flex justify-center gap-4 flex-wrap">
          <a
            href={whatsapp}
            target="_blank"
            rel="noreferrer"
            className="bg-accent text-black px-6 py-3 rounded-lg font-semibold shadow hover:scale-105 transition"
          >
            Donate Now
          </a>

          <a
            href="#donate"
            className="border border-white px-6 py-3 rounded-lg hover:bg-white hover:text-primary transition"
          >
            Learn More
          </a>
        </div>
        </div>
      </section>

      {/* ================= IMPACT QUOTE ================= */}
{/* ================= IMPACT QUOTE ================= */}
<section className="relative py-28 px-6 overflow-hidden" >
   
  {/* background gradient */}
  <div className="absolute inset-0 bg-gradient-to-br from-slate-800 via-gray-900 to-slate-900"></div>

  {/* glow effects */}
  <div className="absolute w-72 h-72 bg-white/10 rounded-full blur-3xl top-10 left-10"></div>
  <div className="absolute w-72 h-72 bg-white/10 rounded-full blur-3xl bottom-10 right-10"></div>

  <div className="relative max-w-4xl mx-auto text-center text-white">

    {/* quote mark */}
    <div className="text-6xl md:text-7xl font-serif opacity-30 leading-none mb-6">
      “
    </div>

    <p className="text-2xl md:text-4xl font-semibold leading-relaxed tracking-wide">
      When you empower a woman, you uplift a family.  
      <br className="hidden md:block" />
      When you educate a youth, you empower a generation.
    </p>

    <div className="w-16 h-1 bg-accent mx-auto my-8 rounded"></div>

    <p className="text-blue-100 text-lg max-w-2xl mx-auto">
      This initiative is not just about infrastructure — it is about creating
      opportunity, restoring dignity, and building a better future.
    </p>

  </div>
</section>

 {/* ================= MODERN SLIDESHOW ================= */}
<section className="max-w-6xl mx-auto px-6 py-16 hidden">
  <div className="relative h-[280px] md:h-[420px] rounded-2xl overflow-hidden shadow-lg group">

    {/* Slides */}
    {SLIDES.map((_, i) => (
  <div
    key={i}
    className={`absolute inset-0 transition-opacity duration-700 ${
      i === current ? "opacity-100 z-10" : "opacity-0 z-0"
    }`}
  >
    <img
      src={SLIDES[i]}
      alt={`slide-${i}`}
      className="w-full h-full object-cover"
    />

    <div className="absolute inset-0 bg-black/20"></div>
  </div>
))}

    {/* LEFT BUTTON */}
    <button
      onClick={() =>
        setCurrent((prev) =>
          prev === 0 ? SLIDES.length - 1 : prev - 1
        )
      }
      className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 backdrop-blur p-2 rounded-full shadow opacity-0 group-hover:opacity-100 transition"
    >
      ‹
    </button>

    {/* RIGHT BUTTON */}
    <button
      onClick={() =>
        setCurrent((prev) =>
          (prev + 1) % SLIDES.length
        )
      }
      className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 backdrop-blur p-2 rounded-full shadow opacity-0 group-hover:opacity-100 transition"
    >
      ›
    </button>

    {/* DOTS */}
    <div className="absolute bottom-4 w-full flex justify-center gap-2">
      {SLIDES.map((_, i) => (
        <button
          key={i}
          onClick={() => setCurrent(i)}
          className={`w-3 h-3 rounded-full transition ${
            i === current ? "bg-white scale-110" : "bg-white/50"
          }`}
        />
      ))}
    </div>

  </div>
</section>

      {/* ================= INTRO ================= */}
      <section className="max-w-5xl mx-auto px-6 py-20">
        <h2 className="text-3xl font-bold mb-6">Introduction</h2>
        <p className="text-gray-500 leading-relaxed">
          {/* {TRUST_NAME} is establishing a Women Empowerment & Skill Development
          Centre and a Computer Lab & Digital Learning Academy in Nandurbar.
          This initiative is aimed at uplifting underprivileged communities through
          education, skills, and sustainable livelihood opportunities. */}

          {TRUST_NAME} is pleased to present this proposal for the establishment of a Women Empowerment & Skill Development Centre and a Computer Lab & Digital Learning Academy in Nandurbar.

This initiative is driven by our commitment to uplifting underprivileged communities through education, skill development, and sustainable livelihood opportunities. The newly acquired facility will serve as a hub for social, educational, and charitable programs aimed at long-term community transformation.

        </p>
      </section>

      {/* ================= VISION MISSION ================= */}
      <section className="py-24 bg-white">
  <div className="max-w-6xl mx-auto px-6">

    <h2 className="text-3xl font-bold mb-12">
      Vision & Mission
    </h2>

    <div className="grid md:grid-cols-2 gap-10">

      {/* Vision */}
      <div className="border-l-4 border-primary pl-6">
        <h3 className="text-xl font-semibold mb-3 text-primary">
          Vision
        </h3>
        <p className="text-gray-600 leading-relaxed">
          To build a self-reliant and empowered society where women and youth
          are equipped with the skills and confidence to lead dignified lives.
        </p>
      </div>

      {/* Mission */}
      <div className="border-l-4 border-secondary pl-6">
        <h3 className="text-xl font-semibold mb-3 text-secondary">
          Mission
        </h3>
        <p className="text-gray-600 leading-relaxed">
          To provide accessible vocational and digital education that fosters
          independence, employability, and long-term economic stability.
        </p>
      </div>

    </div>

  </div>
</section>
      {/* ================= COMPONENTS ================= */}
      <section id="donate" className="max-w-6xl mx-auto px-6 py-20">
        <h2 className="text-3xl font-bold mb-10">Project Components</h2>

            <div className="space-y-16">

  {/* ================= WOMEN EMPOWERMENT ================= */}
  <div className="grid lg:grid-cols-2 gap-10 items-center">

    {/* LEFT CONTENT */}
    <div className="bg-white p-8 md:p-10 rounded-3xl shadow-lg">

      <div className="flex items-center gap-4 mb-6">
        <div className="w-14 h-14 rounded-2xl bg-emerald-100 flex items-center justify-center text-3xl">
          🧵
        </div>

        <h3 className="text-2xl font-bold leading-tight">
          Women Empowerment Centre
        </h3>
      </div>

      <p className="text-gray-600 leading-relaxed mb-8 ">
        The Women Empowerment Center in Nandurbar is a dedicated
        space where women gain skills, confidence, and financial
        independence. Equipped with modern sewing machines,
        spacious worktables, and all essential accessories,
        the center offers hands-on tailoring and stitching
        training designed to open doors to sustainable livelihoods.
      </p>

      {/* FEATURES */}
      <div className="grid sm:grid-cols-2 gap-4 mb-8">

        <div className="bg-gray-50 p-4 rounded-2xl">
          ✅ 10 Sewing Machines
        </div>

        <div className="bg-gray-50 p-4 rounded-2xl">
          ✅ Training Infrastructure
        </div>

        <div className="bg-gray-50 p-4 rounded-2xl">
          ✅ Furniture Setup
        </div>

        <div className="bg-gray-50 p-4 rounded-2xl">
          ✅ Skill Development
        </div>

      </div>

      {/* BUDGET */}
      <div className="bg-emerald-50 rounded-2xl p-6">

        <div className="flex justify-between mb-3">
          <span>Sewing Machines</span>
          <span className="font-semibold">₹185,000</span>
        </div>

        <div className="flex justify-between mb-3">
          <span>Furniture & Setup</span>
          <span className="font-semibold">₹40,000</span>
        </div>

        <div className="border-t border-emerald-200 pt-4 flex justify-between text-xl font-bold">
          <span>Total</span>
          <span>₹225,000</span>
        </div>

      </div>
    </div>

    {/* RIGHT SLIDER */}
    <div className="relative h-[320px] md:h-[520px] rounded-3xl overflow-hidden shadow-xl group">

      {SLIDES_WE.map((_, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === currentWE
              ? "opacity-100 z-10"
              : "opacity-0 z-0"
          }`}
        >
          <img
            src={SLIDES_WE[i]}
            alt=""
            className="w-full h-full object-fill"
          />

          <div className="absolute inset-0 bg-black/20"></div>
        </div>
      ))}

      {/* LEFT BUTTON */}
      <button
        onClick={() =>
          setCurrentWE((prev) =>
            prev === 0
              ? SLIDES_WE.length - 1
              : prev - 1
          )
        }
        className="absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-white/80 backdrop-blur p-3 rounded-full opacity-0 group-hover:opacity-100 transition"
      >
        ‹
      </button>

      {/* RIGHT BUTTON */}
      <button
        onClick={() =>
          setCurrentWE((prev) =>
            (prev + 1) % SLIDES_WE.length
          )
        }
        className="absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-white/80 backdrop-blur p-3 rounded-full opacity-0 group-hover:opacity-100 transition"
      >
        ›
      </button>

      {/* DOTS */}
      <div className="absolute bottom-5 w-full flex justify-center gap-2 z-20">

        {SLIDES_WE.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrentWE(i)}
            className={`w-3 h-3 rounded-full transition ${
              i === currentWE
                ? "bg-white scale-125"
                : "bg-white/50"
            }`}
          />
        ))}

      </div>
    </div>
  </div>

  {/* ================= COMPUTER LAB ================= */}
  <div className="grid lg:grid-cols-2 gap-10 items-center">

    {/* IMAGE LEFT */}
    <div className="relative order-2 lg:order-1 h-[320px] md:h-[520px] rounded-3xl overflow-hidden shadow-xl group">

      {SLIDES_DL.map((_, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === currentDL
              ? "opacity-100 z-10"
              : "opacity-0 z-0"
          }`}
        >
          <img
            src={SLIDES_DL[i]}
            alt=""
            className="w-full h-full object-fill"
          />

          <div className="absolute inset-0 bg-black/20"></div>
        </div>
      ))}

      <button
        onClick={() =>
          setCurrentDL((prev) =>
            prev === 0
              ? SLIDES_DL.length - 1
              : prev - 1
          )
        }
        className="absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-white/80 backdrop-blur p-3 rounded-full opacity-0 group-hover:opacity-100 transition"
      >
        ‹
      </button>

      <button
        onClick={() =>
          setCurrentDL((prev) =>
            (prev + 1) % SLIDES_DL.length
          )
        }
        className="absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-white/80 backdrop-blur p-3 rounded-full opacity-0 group-hover:opacity-100 transition"
      >
        ›
      </button>

      <div className="absolute bottom-5 w-full flex justify-center gap-2 z-20">

        {SLIDES_DL.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrentDL(i)}
            className={`w-3 h-3 rounded-full transition ${
              i === currentDL
                ? "bg-white scale-125"
                : "bg-white/50"
            }`}
          />
        ))}

      </div>
    </div>

    {/* CONTENT RIGHT */}
    <div className="order-1 lg:order-2 bg-white p-8 md:p-10 rounded-3xl shadow-lg">

      <div className="flex items-center gap-4 mb-6">
        <div className="w-14 h-14 rounded-2xl bg-blue-100 flex items-center justify-center text-3xl">
          💻
        </div>

        <h3 className="text-2xl font-bold leading-tight">
          Computer Lab & Digital Academy
        </h3>
      </div>

      <p className="text-gray-600 leading-relaxed mb-8 ">
        The Computer Lab & Digital Academy in Nandurbar district
        is a modern learning space designed to bring digital
        skills to the youth of the region and to promote digital literacy and provide career-oriented computer education to students, graduates, and working individuals.
      </p>
        {/* FEATURES */}
      <div className="grid sm:grid-cols-2 gap-4 mb-8">


        <div className="bg-gray-50 p-4 rounded-2xl">
          ✅ 10 Computer Systems with Printer

        </div>

        <div className="bg-gray-50 p-4 rounded-2xl">
          ✅ Furniture & Lab Setup
        </div>

        

      </div>
      <div className="bg-blue-50 rounded-2xl p-6">

        <div className="flex justify-between mb-3">
          <span>Computer Systems</span>
          <span className="font-semibold">₹650,000</span>
        </div>

        <div className="flex justify-between mb-3">
          <span>Furniture & Setup</span>
          <span className="font-semibold">₹50,000</span>
        </div>

        <div className="border-t border-blue-200 pt-4 flex justify-between text-xl font-bold">
          <span>Total</span>
          <span>₹700,000</span>
        </div>

      </div>

    </div>
  </div>

</div>



        
      </section>

      {/* ================= IMPACT ================= */}
      <section className="py-24 bg-gradient-to-b from-white to-soft">
  <div className="max-w-6xl mx-auto px-6">

    <h2 className="text-3xl font-bold text-center mb-16">
      Transforming Lives Through Impact
    </h2>

    <div className="grid md:grid-cols-2 gap-10">

      {[
        {
          title: "Women Empowerment",
          desc: `• Financial independence for women
• Skill-based employment opportunities
• Improved quality of life for families
• Social upliftment through self-reliance`
        },
        {
          title: "Youth Employment",
          desc: `• Enhanced digital skills and employability
• Access to modern education tools
• Opportunities in freelancing and corporate sectors
• Bridging the digital divide in rural and semi-urban communities`
        },
        {
          title: "Family Upliftment",
          desc: "Improved income leads to better living standards and education for families."
        },
        {
          title: "Stronger Communities",
          desc: "Self-reliant individuals contribute to sustainable community development."
        }
      ].map((item, i) => (
        <div
          key={i}
          className="flex gap-4 items-start bg-white p-6 rounded-2xl shadow hover:shadow-lg transition"
        >
          <div className="w-12 h-12 flex items-center justify-center bg-primary text-white rounded-xl font-bold">
            {i + 1}
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-1">{item.title}</h3>
            <p className="text-gray-500 text-sm whitespace-pre-line">{item.desc}</p>
          </div>
        </div>
      ))}

    </div>
  </div>
</section>

      {/* ================= DONATION BREAKDOWN ================= */}
{/* ================= DONATION BREAKDOWN ================= */}
<section className="py-24 bg-white">
  <div className="max-w-[1400px] mx-auto px-6">

    <h2 className="text-3xl font-bold mb-16 text-center">
      Choose How You Want to Make an Impact
    </h2>

    {/* ✅ CARDS */}
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

      {DONATION_DATA.map((item, i) => {
        const isActive = activeDonate === i;

        return (
          <div
            key={i}
            onClick={() => {
              setActiveDonate(isActive ? null : i);
              setDonateSlide(0);
            }}
            className={`relative cursor-pointer bg-soft border rounded-2xl p-8 transition ${
              isActive
                ? "ring-2 ring-primary shadow-xl"
                : "hover:shadow-xl hover:-translate-y-1"
            }`}
          >

            {(item.highlight || i === 1) && (
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-accent text-black px-3 py-1 text-xs rounded-full font-semibold">
                High Impact
              </div>
            )}

            <h3 className="font-semibold text-lg mb-3">
              {item.title}
            </h3>

            <p className="text-gray-500 mb-6 text-sm">
              {item.desc}
            </p>

            <p className="text-2xl font-bold mb-6">
              {item.price}
            </p>

            <a              
              onClick={() => {
              setActiveDonate(isActive ? null : i);
              setDonateSlide(0);
              }}
              className="inline-block bg-primary text-white px-5 py-2 rounded-lg text-sm"
            >
              View More
            </a>


                {/* MOBILE EXPANDED SECTION */}
              {isActive && (
                <div className="block lg:hidden mt-6 border-t pt-6">

                  <div className="relative h-64 rounded-xl overflow-hidden mb-6">

                    <img
                      src={DONATION_DATA[i].images[donateSlide]}
                      className="w-full h-full object-fit"
                      alt=""
                    />

                    {/* LEFT */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();

                        setDonateSlide((prev) =>
                          prev === 0
                            ? DONATION_DATA[i].images.length - 1
                            : prev - 1
                        );
                      }}
                      className="absolute left-3 top-1/2 -translate-y-1/2 bg-white/80 p-2 rounded-full"
                    >
                      ‹
                    </button>

                    {/* RIGHT */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();

                        setDonateSlide((prev) =>
                          (prev + 1) % DONATION_DATA[i].images.length
                        );
                      }}
                      className="absolute right-3 top-1/2 -translate-y-1/2 bg-white/80 p-2 rounded-full"
                    >
                      ›
                    </button>
                  </div>

                  <p className="text-gray-600 leading-relaxed mb-6">
                    {DONATION_DATA[i].details}
                  </p>

                  <a
                    href={whatsapp}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-block bg-accent text-black px-6 py-3 rounded-lg font-semibold"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Sponsor This Initiative
                  </a>
                </div>
              )}
          </div>
        );
      })}

    </div>

    {/* ✅ EXPANDED SECTION (FULL WIDTH — FIXES YOUR PROBLEM) */}
    {activeDonate !== null && (
      <div className="hidden lg:grid mt-16 bg-white rounded-2xl shadow-xl p-6 md:p-10 grid-cols-2 gap-10 items-center">

        {/* IMAGE */}
        <div className="relative h-64 md:h-[380px] rounded-xl overflow-hidden">

          <img
            src={DONATION_DATA[activeDonate].images[donateSlide]}
            className="w-full h-full object-fit"
            alt=""
          />

          {/* LEFT */}
          <button
            onClick={() =>
              setDonateSlide((prev) =>
                prev === 0
                  ? DONATION_DATA[activeDonate].images.length - 1
                  : prev - 1
              )
            }
            className="absolute left-3 top-1/2 -translate-y-1/2 bg-white/80 p-2 rounded-full"
          >
            ‹
          </button>

          {/* RIGHT */}
          <button
            onClick={() =>
              setDonateSlide((prev) =>
                (prev + 1) %
                DONATION_DATA[activeDonate].images.length
              )
            }
            className="absolute right-3 top-1/2 -translate-y-1/2 bg-white/80 p-2 rounded-full"
          >
            ›
          </button>

          {/* DOTS */}
          <div className="absolute bottom-4 w-full flex justify-center gap-2">
            {DONATION_DATA[activeDonate].images.map((_, idx) => (
              <div
                key={idx}
                className={`w-3 h-3 rounded-full ${
                  idx === donateSlide ? "bg-white" : "bg-white/50"
                }`}
              />
            ))}
          </div>
        </div>

        {/* TEXT */}
        <div className="text-left">
          <h3 className="text-2xl font-bold mb-4">
            {DONATION_DATA[activeDonate].title}
          </h3>

          <p className="text-gray-600 leading-relaxed mb-6">
            {DONATION_DATA[activeDonate].details}
          </p>

          <a
            href={whatsapp}
            target="_blank"
            rel="noreferrer"
            className="inline-block bg-accent text-black px-6 py-3 rounded-lg font-semibold"
          >
            Sponsor This Initiative
          </a>
        </div>

      </div>
    )}

  </div>
</section>

      {/* ================= DONATION ================= */}
      <section  className="bg-secondary text-white py-20 text-center px-6">

        <h2 className="text-3xl font-bold mb-4">
          Support This Initiative
        </h2>

        <p className="mb-6 text-teal-100">
          Your contribution creates real impact.
        </p>

        <p className="text-2xl font-bold mb-8">
          Total Required: {TOTAL_AMOUNT}
        </p>

        <div className="flex justify-center mb-8">
        <div className="bg-white p-3 rounded-xl shadow">
  <img
    src={qr}
    alt="QR Code"
    className="w-80 h-80  object-contain"
  />
</div>
        </div>

        <a
          href={whatsapp}
          target="_blank"
          rel="noreferrer"
          className="bg-accent text-black px-8 py-4 rounded-xl font-semibold shadow hover:scale-105 transition"
        >
          Contact via WhatsApp
        </a>

      </section>

    </div>
  );
}

export default App;